import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from "react-redux";

import ClientLogin from './User/login.js';
import ClientMain from './User/components/main.js';
import ClientRacuni from './User/components/Racuni/main.js'
import ClientSettings from './User/components/Settings/main.js'
import ClientIzvjestaji from './User/components/Izvjestaji/main.js'

import AdminLogin from './Admin/login.js';
import AdminSettings from './Admin/components/Settings/main.js'
import AdminClient from './Admin/components/Client/main.js'
import AdminClientCreate from './Admin/components/Client/Create.js'
import AdminMain from './Admin/components/main.js'
import AdminClientDetails from './Admin/components/Client/Details.js'

import Restricted403 from './403.js'

export class Main extends React.Component{
  constructor() {
    super();
    this.state = {
      authenticated: false,
      loading: true
    };
  }

  componentDidMount() {      
  }

  render(){	  
    	return(
      		<div className="" id="table-container" style={{height: "inherit"}}>
				<Switch>            
					<Route exact path='/' component={ClientLogin}/>    
					<Route exact path='/Admin/' component={AdminLogin}/>                       
					

					{this.props.role === "client" ?
					<ClientMain>
						<Route component={({ match }) =>
							
							<Route exact path='/Client/racuni/' component={ClientRacuni}/>

						}/>
						<Route component={({ match }) =>
							
							<Route exact path='/Client/settings/' component={ClientSettings}/>
						}/>                  
						<Route component={({ match }) =>
						
							<Route exact path='/Client/dashboard/' component={ClientMain}/>  
						
						}/>

						<Route component={({ match }) =>
						
							<Route exact path='/Client/izvjestaji/' component={ClientIzvjestaji}/>  
						
						}/>
						
					</ClientMain>	
					
					:

					<AdminMain>
						<Route component={({ match }) =>
							
							<Route exact path='/Admin/dashboard' component={AdminMain}/>  

						}/>

						<Route component={({ match }) =>
							
							<Route exact path='/Admin/client' component={AdminClient}/>	

						}/>

						<Route component={({ match }) =>
							
							<Route exact path='/Admin/settings' component={AdminSettings}/>	

						}/>       

                        <Route component={({ match }) =>
							
							<Route exact path='/Admin/client/create' component={AdminClientCreate}/>	

						}/>  

                        <Route component={({ match }) =>
							
							<Route exact path='/Admin/client/:id' component={AdminClientDetails}/>	

						}/>           
						

					</AdminMain>

  					}	

					<Route path="/404" component={Restricted403} />
					<Redirect to="/404" />

				</Switch>
			</div>            
		) 															
  	} 
}

const mapStateToProps = state => {
  return {   
	  role: state.user.role
  };
};

const mapDispatchToProps = dispatch => {
  return {
    mapState: (type, data) => dispatch({ type: type, data: data})
  };
};



export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Main);
